module.exports = __webpack_public_path__ + "media/bootstrap-icons/envelope-fill-9603dc70.svg";